import { Injectable, OnDestroy } from '@angular/core';
import { EnumsTexts } from '@language/interfaces/enums-interfaces';
import { ErrorTexts } from '@language/interfaces/error-interfaces';
import { EventsDescriptionTexts } from '@language/interfaces/events-description-texts-interfaces';
import { Languages, Texts } from '@language/interfaces/interfaces';
import errorFiles from '@language/languages/en/en.error.json';
import networkErrorsFiles from '@language/languages/en/en.networkErrors.json';
import eventFile from '@language/languages/en/en.eventsDescriptionTexts.json';
import translationFile from '@language/languages/en/en.translation.json';
import enumsFile from '@language/languages/en/en.enums.json';
import { NsEnum } from '@uigy/shared/constants/language.constants';
import { Language } from '@uigy/shared/models/language';
import { LanguageService } from '@uigy/shared/services/language.service';
import { Observable, of, ReplaySubject } from 'rxjs';
import { NetworkErrorsTexts } from '@language/interfaces/network-errors-interfaces';

@Injectable()
export class LanguageStubService implements Omit<LanguageService, 'DEFAULT_LANGUAGE' | 'i18NextService' | 'storageService'>, OnDestroy {
  public texts: Texts = {
    ...eventFile,
    ...translationFile,
  };

  public errorTexts: ErrorTexts = errorFiles;
  public networkErrorsTexts: NetworkErrorsTexts = networkErrorsFiles;
  public eventsDescriptionText: EventsDescriptionTexts = eventFile;
  public enumsTexts: EnumsTexts = enumsFile;
  public languages: Language[] = this.getLanguages();
  public language: Language = this.languages[0];
  public initialized$ = new ReplaySubject<void>(1);

  constructor() {
    this.initialized$.next();
  }

  public formatEnum<K extends keyof EnumsTexts>(enumType: K, key: keyof EnumsTexts[K]): string {
    return 'enum';
  }

  public changeLanguage(): void {
  }

  // intentionally empty
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngOnDestroy(): void {
  }

  public getResource<T = any>(key: string, ns: NsEnum = NsEnum.translation, options?: T): any {
    return this.texts;
  }

  public getTranslationTyped<T = any>(key: string, options?: T): any {
    return this.texts;
  }

  public getErrorTyped<T = any>(key: string, options?: T): any {
    return this.texts;
  }

  public getNetworkErrorsTyped<T = any>(key: string, options?: T): any {
    return this.texts;
  }

  public getEventsDescriptionTyped<T = any>(key: string, options?: T): any {
    return this.texts;
  }

  public getEnumsTyped<T = any>(key: string, options?: T): any {
    return this.texts;
  }

  public getLanguages(): Language[] {
    return Array.from(Object.entries(this.texts._languages)).map(([k, v]) => ({key: k as keyof Languages, value: v}));
  }

  public getSelectedLanguage(): Observable<Language> {
    return of(this.language!);
  }
}
